import { IAccessTokenManager } from '@/store/spi/api'

const storageKey = 'access_token'

export class LocalStorageAccessTokenManager implements IAccessTokenManager {
  get(): string | null {
    return localStorage.getItem(storageKey)
  }
  set(accessToken: string): void {
    localStorage.setItem(storageKey, accessToken)
  }
  clear(): void {
    localStorage.removeItem(storageKey)
  }
}
